<template>
  <div class="blog-recent-posts">
    <BaseText class="bold">{{ $t("blog.recent-posts") }}</BaseText>
    <BaseList>
      <BaseListItem v-for="post in recentPosts" :key="post.path">
        <NuxtLink
          :to="localePath(`/blog${post.path}`)"
          class="blog-post-link"
          >{{ post.title }}</NuxtLink
        >
      </BaseListItem>
    </BaseList>
    <div class="ads mt-2">
      <Advertisement
        :display-at="AdDisplayAt.BlogDetailTop"
        class="hide-small"
      />
      <Advertisement :display-at="AdDisplayAt.BlogDetailBottom" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  WebsitePostOrderBy,
  useWebsitePostsQuery,
  AdDisplayAt,
} from "~/graphql/generated";

const props = defineProps<{
  currentPostPath: string;
}>();

const localePath = useLocalePath();

/*
 * Fetch the most recent posts
 */
const { data: recentPostData, error } = await useWebsitePostsQuery({
  variables: {
    websitePosts: {
      orderBy: WebsitePostOrderBy.PublishedAtDesc,
    },
    pagination: {
      limit: 6,
      offset: 0,
    },
  },
  requestPolicy: "network-only",
});
// Return the most recent posts, but filter out the current post. If the current post is not found, return the first 5 posts from the array.
const recentPosts = computed(() => {
  if (error?.value || !recentPostData.value?.websitePosts) return [];

  const filteredPosts = recentPostData.value.websitePosts.filter(
    (post) => post.path !== props.currentPostPath
  );

  return filteredPosts.length > 0
    ? filteredPosts.slice(0, 5)
    : recentPostData.value.websitePosts.slice(0, 5);
});
</script>

<style lang="scss" scoped>
.blog-recent-posts {
  width: 400px;
  max-width: 100%;

  .blog-post-link {
    transition: all $easing;
    text-decoration: underline solid transparent;

    &:hover {
      color: var(--primary);
      text-decoration: underline solid currentColor;
    }
  }
  .ads {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}
</style>
